module.exports = __webpack_public_path__ + "static/media/country_br.2a769feb.webp";